// extracted by mini-css-extract-plugin
export var list = "datenschutz-module--list--9813f";